import { PERIOD, TITLE } from '../../constants/shared/CommonConstants';
import { getNavigationUrl } from './urlUtils';
import { SHARED_API_URL } from '../../constants/shared/ApiConstants';

const { BOY, MOY, EOY, SUMMER, SUMMARY } = PERIOD;
const { BOY_TITLE, MOY_TITLE, EOY_TITLE, SUMMARY_TITLE, SUMMER_TITLE } = TITLE;

export const getDisabledTabIdsForPeriod = currentPeriod => {
    switch (currentPeriod) {
        case BOY:
            return [MOY, EOY, SUMMER];
        case MOY:
            return [EOY, SUMMER];
        case EOY:
            return [SUMMER];
        default:
            return [];
    }
};

export const toyTabs = (
    location,
    url,
    optionalParams,
    isSummerPeriodPresent = false,
    summerPeriodLabel = SUMMER_TITLE,
) => {
    const tabsSet = [
        {
            id: BOY,
            path: getNavigationUrl(location, url, { period: BOY, ...optionalParams }),
            title: BOY_TITLE,
        },
        {
            id: MOY,
            path: getNavigationUrl(location, url, { period: MOY, ...optionalParams }),
            title: MOY_TITLE,
        },
        {
            id: EOY,
            path: getNavigationUrl(location, url, { period: EOY, ...optionalParams }),
            title: EOY_TITLE,
        },
    ];

    // Prior to 03/20/2025, all three tabs were always visible.
    // But the Summer period tab should be displayed
    // only if it is available for the selected institution.
    if (isSummerPeriodPresent) {
        tabsSet.push({
            id: SUMMER,
            path: getNavigationUrl(location, url, { period: SUMMER, ...optionalParams }),
            title: summerPeriodLabel,
        });
    }

    if (url.includes(SHARED_API_URL().BASE_URLS.BENCHMARK_URL)) {
        tabsSet.push({
            id: SUMMARY,
            path: getNavigationUrl(location, url, { period: SUMMARY, ...optionalParams }),
            title: SUMMARY_TITLE,
        });
    }
    return tabsSet;
};
